const FALLBACK_ORIGIN = "https://societea.app";

const getRuntimeOrigin = (): string => {
  if (typeof window === "undefined" || !window.location?.origin) {
    return FALLBACK_ORIGIN;
  }

  return window.location.origin.replace(/\/$/, "");
};

const normalizePathname = (pathname: string): string =>
  pathname.startsWith("/") ? pathname : `/${pathname}`;

/**
 * Build a locale-neutral `/s/*` URL for outbound sharing.
 */
export const buildShareRouteUrl = (pathname: string): string =>
  `${getRuntimeOrigin()}/s${normalizePathname(pathname)}`;

/**
 * Build a canonical entity profile path before wrapping it in `/s/`.
 *
 * `entityType` is the canonical kind (matches `posts.kind` and the entity
 * view's `entity_type` column). Teabates are passed as `'teabate'`; the
 * pre-unification `isTeabate` boolean parameter was removed once the
 * unified-posts migration backfilled every post row.
 */
export const buildEntitySharePath = (
  entityType: string,
  entityId: number | string
): string => `/${entityType}/${encodeURIComponent(String(entityId))}`;

/**
 * Build the share route for a comment deep link.
 */
export const buildCommentSharePath = (commentId: number | string): string =>
  `/comment/${encodeURIComponent(String(commentId))}`;

/**
 * Build the share route for quiz invites.
 */
export const buildQuizSharePath = (code: string): string =>
  `/quiz/${encodeURIComponent(code.trim().toLowerCase())}`;
